<template>
    <v-dialog v-model="editUserDialog" max-width="600" persistent>
        <template v-slot:activator="{ on }">
            <v-btn color="primary" text v-on="on">Edit</v-btn>
        </template>
        <v-card flat>
            <v-card-title class="flex-nowrap align-start">
                <div class="d-flex align-center secondary--text">
                    <span>Edit Personal Information</span>
                </div>

                <v-spacer></v-spacer>
                <v-btn :disabled="saving" @click="editUserDialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-form ref="editForm" v-model="formValid" @submit.prevent="saveUserInfo">
                    <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                            <v-text-field
                                ref="firstNameField"
                                v-model="editedFirstName"
                                label="First name"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :disabled="saving"
                                required></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                            <v-text-field
                                ref="lastNameField"
                                v-model="editedLastName"
                                label="Last name"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :disabled="saving"
                                required></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
                <v-alert v-if="error" type="error" text>Failed to update personal information. If the problem persists, contact support.</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div>
                    <v-btn color="success" v-if="showSuccess"><v-icon>mdi-check</v-icon></v-btn>
                    <v-btn v-else :disabled="!formValid || !hasChanges || saving" :loading="saving" color="primary" text @click="saveUserInfo">
                        Save Changes
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'UserPersonalInfoEditDialog',
    props: {
        userInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            error: false,
            showSuccess: false,
            saving: false,
            editUserDialog: false,
            formValid: false,
            editedFirstName: '',
            editedLastName: '',
            rules: {
                required: v => !!v || 'Field is required'
            }
        }
    },
    computed: {
        hasChanges() {
            return this.editedFirstName !== this.userInfo.given_name || this.editedLastName !== this.userInfo.family_name
        }
    },
    watch: {
        editUserDialog(newVal) {
            if (newVal) {
                this.initializeForm()
            } else {
                this.resetForm()
            }
        }
    },
    methods: {
        initializeForm() {
            this.editedFirstName = this.userInfo.given_name || ''
            this.editedLastName = this.userInfo.family_name || ''
            this.error = false

            this.showSuccess = false

            // Reset form validation
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.resetValidation()
                }
            })
        },

        resetForm() {
            this.editedFirstName = ''
            this.editedLastName = ''
            this.error = false

            this.showSuccess = false
            this.saving = false
        },

        cancelEdit() {
            this.editUserDialog = false
        },

        async saveUserInfo() {
            if (!this.hasChanges) {
                this.editUserDialog = false
                return
            }

            this.saving = true
            this.error = false

            try {
                const payload = {
                    given_name: this.editedFirstName.trim(),
                    family_name: this.editedLastName.trim()
                }

                await this.$axios.patch('/users/current', payload)
                this.showSuccess = true
                setTimeout(() => {
                    this.editUserDialog = false
                    this.$store.dispatch('getUserInfo')
                }, 2000)
            } catch (error) {
                console.error('Error updating user info:', error)
                this.error = true
            } finally {
                this.saving = false
            }
        }
    }
}
</script>
